import { initLogger } from "@swa-ui/dotcom";

initLogger("inflight-home-page");
